<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-video', fontSet: 'fad'}"
	[headerText]="(T.CAMERA_PREVIEW_DIALOG_HEADER | translate) + camera?.name"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<div dialogContent>
		<div class="bottom">
			@if (camera) {
				<sim-recorder-camera-fin [isSingleView]="true" [liveStreamCameraLayoutOptions]="options" [screen]="camera" />
			}
		</div>
	</div>
</sim-basic-material-dialog>
